export class PbdcDocumentos {

    static pbbDocumentosLista: PbdcDocumentos[] = [
        { tipo: 'pdf', descricao: 'PBDC - Destinação de Superávit 2009', caminho: 'pbdc_proposta_destinacao_2009.pdf' },
        { tipo: 'pdf', descricao: 'PBDC - Destinação de Superávit 2012', caminho: 'pbdc_destinacao_superavit_2012.pdf' },
        { tipo: 'pdf', descricao: 'PBDC - Destinação de Superávit 2014', caminho: 'pbdc_destinacao_superavit_2014.pdf' },
        { tipo: 'pdf', descricao: 'PBDC - Destinação De Superavit 2016', caminho: 'pbdc_destinacao_reserva_especial_2016.pdf' },
        { tipo: 'pdf', descricao: 'PBDC - Destinação De Superavit 2017', caminho: 'pbdc_destinacao_reserva_especial_2017.pdf' },
        { tipo: 'pdf', descricao: 'PBDC - Destinação De Superavit 2018', caminho: 'pbdc_destinacao_reserva_especial_2018.pdf' }
    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {
    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/pbdc-documentos.ts